import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserProfileList } from '../../api/userProfile';
import { message } from 'antd';

// 获取用户资料列表
export const fetchUserProfiles = createAsyncThunk(
  'userProfile/fetchUserProfiles',
  async (params, { rejectWithValue }) => {
    try {
      const response = await getUserProfileList(params);
      return response.data;
    } catch (error) {
      message.error('获取用户资料列表失败');
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  userProfileList: {
    data: [],
    total: 0,
    current: 1,
    size: 10,
    loading: false,
    searchParams: {
      userId: undefined,
      nickname: undefined,
      gender: undefined,
      province: undefined,
      city: undefined,
      district: undefined,
      isPublic: undefined,
      startTime: undefined,
      endTime: undefined
    }
  }
};

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      state.userProfileList.searchParams = {
        ...state.userProfileList.searchParams,
        ...action.payload
      };
      
      // 如果传入了页码或每页条数，更新对应的值
      if (action.payload.page) {
        state.userProfileList.current = action.payload.page;
      }
      
      if (action.payload.size) {
        state.userProfileList.size = action.payload.size;
      }
    },
    resetSearchParams: (state) => {
      state.userProfileList.searchParams = {
        userId: undefined,
        nickname: undefined,
        gender: undefined,
        province: undefined,
        city: undefined,
        district: undefined,
        isPublic: undefined,
        startTime: undefined,
        endTime: undefined
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserProfiles.pending, (state) => {
        state.userProfileList.loading = true;
      })
      .addCase(fetchUserProfiles.fulfilled, (state, action) => {
        state.userProfileList.loading = false;
        state.userProfileList.data = action.payload.records;
        state.userProfileList.total = action.payload.total;
        state.userProfileList.current = action.payload.current;
        state.userProfileList.size = action.payload.size;
      })
      .addCase(fetchUserProfiles.rejected, (state) => {
        state.userProfileList.loading = false;
      });
  }
});

export const { setSearchParams, resetSearchParams } = userProfileSlice.actions;
export default userProfileSlice.reducer; 